import { configureStore, combineReducers } from "@reduxjs/toolkit"; // Add combineReducers
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import productReducer from "./slices/productSlice";
import branchReducer from "./slices/branchSlice";
import orderReducer from "./slices/orderSlice";
import supplierReducer from "./slices/supplierSlice";
import inventoryReducer from "./slices/inventorySlice";
import stockMovementReducer from "./slices/stockMovement";
import customerReducer from "./slices/customerSlice";
import productSettingReducer from "./slices/productSettingSlice";

// Configuration for redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "user",
    "product",
    "branch",
    "order",
    "supplier",
    "inventory",
    "stockMovement",
    "customer",
    "productSetting",
  ], // Specify which reducers to persist
};

// Combine all reducers into a single root reducer
const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  product: productReducer,
  branch: branchReducer,
  order: orderReducer,
  supplier: supplierReducer,
  inventory: inventoryReducer,
  stockMovement: stockMovementReducer,
  customer: customerReducer,
  productSetting: productSettingReducer,
});

// Wrap the root reducer with persistReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// Create persistor object
export const persistor = persistStore(store);

export default store;
